/**
 * 모달 열릴 때 overflow hidden으로 레이아웃이 움직이는 현상 방지
 * body의 스크롤 관리
 * elements 배열 요소의 padding-right 값을 설정
 * @param {boolean} isModalOpen - 모달 열려 있는지 여부
 */
export const manageBodyScrollAndPadding = (isModalOpen: boolean) => {
  // 스크롤바 너비 계산
  const scrollBarWidth =
    window.innerWidth - document.documentElement.clientWidth;

  const elements = [
    document.body, // body 영역
    document.querySelector('header') as HTMLElement | null, // pc, mobile GNB 컴포넌트
    document.querySelector('.bottomAppbar') as HTMLElement | null, // BottomAppbar 컴포넌트
    document.querySelector('.tabBar') as HTMLElement | null, // TabBar 컴포넌트
  ];

  /**
   * 요소의 padding-right 값을 설정
   * @param {HTMLElement | null} element - 패딩을 설정할 요소
   * @param {string} value - 설정할 패딩 값
   */
  const setPaddingRight = (element: HTMLElement | null, value: string) => {
    if (element) {
      element.style.paddingRight = value;
    }
  };

  const overflowValue = isModalOpen ? 'hidden' : 'unset';
  const paddingValue = isModalOpen ? `${scrollBarWidth}px` : '0';

  document.body.style.overflow = overflowValue;
  elements.forEach((element) => {
    setPaddingRight(element, paddingValue);
  });
};
